import React from 'react';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import LineStyleOutlinedIcon from '@material-ui/icons/LineStyleOutlined';
import RemoveOutlinedIcon from '@material-ui/icons/RemoveOutlined';
import FilterHdrIcon from '@material-ui/icons/FilterHdr';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import YouTubeIcon from '@material-ui/icons/YouTube';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
const roundImage = {
    hidden: false,
    conditions: [],
    type: 'CIRCLE',
    padding: 0,
    actionLink: null,
    alignment: 'center',
    style: { borderRadius: '50%', width: '210px', height: '210px', maxHeight: 'unset', }
};

const originalImage = {
    hidden: false,
    conditions: [],
    orgSize: {
        height: 0,
        width: 0
    },
    type: 'ORIGINAL',
    padding: 0,
    actionLink: null,
    alignment: 'center',
    style: { width: 'unset', height: 'unset', maxHeight: 'unset', }
};

const calendarInvitation = {
    hidden: false,
    conditions: [],
    invitationId: null,
    type: 'CALENDAR_INVITATION',
    padding: 0,
    alignment: 'center',
    style: { width: 'unset', height: 'unset', maxHeight: 'unset', }
};

const squareImage = {
    hidden: false,
    conditions: [],
    type: 'SQUARE',
    padding: 0,
    actionLink: null,
    alignment: 'center',
    style: { maxHeight: 'unset', height: '210px', width: '210px', borderRadius: '0px', }
}
const fullImage = {
    hidden: false,
    conditions: [],
    padding: 0,
    actionLink: null,
    type: 'FULL',
    style: { maxHeight: 'unset', height: 'auto', width: '100%', borderRadius: '0px' }
}

const googleMap = {
    hidden: false,
    conditions: [],
    zoom: 15,
    padding: 0,
    style: { height: '200px', width: '100%', borderRadius: '0px' }
}

const video = {
    hidden: false,
    conditions: [],
    loop: false,
    autoplay: false,
    padding: 10,
    frame: true,
    thumbnail: '',
    style: { height: '500px', width: '100%' }
}

const text = {
    hidden: false,
    conditions: [],
    padding: 10,
    style: { height: '100%', width: '100%' }
}
const divider = {
    hidden: false,
    conditions: [],
    padding: 0,
    margin: 0,
    borderColor: '#222',
    borderWidth: 0.5,
    borderStyle: 'solid',
    height: 10, width: 100
}

const captcha = {
    hidden: false,
    isValid: false,

}

const button = {
    hidden: false,
    conditions: [],
    padding: '4px 12px 4px 12px',
    alignment: 'center',
    target: 'blank',
    actionLink: '',
    timer: false,
    startDate: null,
    endDate: null,
    style: { height: 'auto', width: 'auto' }
}


export const content = [
    {
        id: 'A', type: 'IMG', settings: roundImage, icon: <FilterHdrIcon style={{
            fontSize: '28px',
            padding: '3px 0px',
            borderRadius: '50%',
            height: '32px',
            width: '32px',
            border: '2px solid rgba(87, 87, 87, 0.83)',
            marginBottom: '3px',
            marginTop: '5px'
        }} />, label: 'RoundImage'
    },
    {
        id: 'B', type: 'IMG', settings: squareImage, icon: <FilterHdrIcon style={{
            fontSize: '28px',
            padding: '3px 0px',
            /*    borderRadius: '50%', */
            height: '32px',
            width: '32px',
            border: '2px solid rgba(87, 87, 87, 0.83)',
            marginBottom: '3px',
            marginTop: '5px'
        }} />, label: 'SquareImageX'
    },
    {
        id: 'C', type: 'IMG', settings: fullImage, icon: <FilterHdrIcon style={{
            fontSize: '28px',
            padding: '2px 0px',
            /*    borderRadius: '50%', */
            height: '32px',
            width: '60px',
            border: '2px solid rgba(87, 87, 87, 0.83)',
            marginBottom: '3px',
            marginTop: '9px'
        }} />, label: 'FullImageX'
    },
    {
        id: 'J', type: 'IMG', settings: originalImage, icon: <FilterHdrIcon style={{
            fontSize: '28px',
            padding: '2px 0px',
            /*    borderRadius: '50%', */
            height: '32px',
            width: '60px',
            marginBottom: '3px',
            marginTop: '9px'
        }} />, label: 'OrgImage'
    },
    { id: 'D', type: 'TEXT', settings: text, icon: <LineStyleOutlinedIcon style={{ fontSize: '40px', padding: '5px 0px' }} />, label: 'TextEditor' },
    { id: 'E', type: 'DIVIDER', settings: divider, icon: <RemoveOutlinedIcon style={{ fontSize: '40px', padding: '5px 0px' }} />, label: 'Divider' },
    { id: 'F', type: 'MAP', settings: googleMap, icon: <RoomOutlinedIcon style={{ fontSize: '40px', padding: '5px 0px' }} />, label: 'GoogleMaps' },
    { id: 'G', type: 'BUTTON', settings: button, icon: <TouchAppIcon style={{ fontSize: '40px', padding: '5px 0px' }} />, label: 'Button' },
    { id: 'H', type: 'VIDEO', settings: video, icon: <YouTubeIcon style={{ fontSize: '40px', padding: '5px 0px' }} />, label: 'VideoElement' },
    { id: 'K', type: 'CALENDAR_INVITATION', settings: calendarInvitation, icon: <CalendarTodayIcon style={{ fontSize: '40px', padding: '5px 0px' }} />, label: 'CalendarInvitation' }

    /*   { id: 'D', type: 'BUTTON', settings: button }, */
    /*     { id: 'C', type: 'VIDEO', description: 'Youtube' },
        { id: 'D', type: 'AUDO', description: 'Audio player' },
        { id: 'E', type: 'MAP', description: 'Google map' },
        { id: 'F', type: 'TEXT', description: 'Text' } */

]
